import React, { Dispatch, FC, SetStateAction } from 'react'
import "../css/headerDropDown.css"
import { useNavigate } from 'react-router-dom'
import { useAppShellCustomState } from '../../../../context-module/context-configuration/auth-provider/appShell/appShellProvider'
import { useCmsGlobals } from '../../../../context-module/context-configuration/auth-provider/appShell/appShellGlobal/appUseGlData'

interface HeaderDropProps {
    setIsMenuOpen: Dispatch<SetStateAction<boolean>>
}

const HeaderDropDown:FC<HeaderDropProps> = ({setIsMenuOpen}) => {
    const navigate = useNavigate()
    const { header } = useAppShellCustomState();
    const { globals } = useCmsGlobals()
    
    const cmsHeader = globals?.header ?? null;
    
    const onClickPath = (pathUrl:string) => {
        setIsMenuOpen(false)
        navigate(pathUrl)
    }
    return (
        <div className='scl--dd-hea-box-cont-stlr'>
            <ul>
                {cmsHeader?.navigation?.items
                .filter((item:any) => item.visible)
                .map((item:any) => (
                    <li key={item?.key}>
                        <button onClick={() => onClickPath(item.path)}>
                            {item.label}
                        </button>
                    </li>
                ))}
                
                <li>
                    <button onClick={() => onClickPath(header.cta.path)}>
                        {cmsHeader?.cta?.content?.label}
                    </button>
                </li>
            </ul>
        </div>
    )
}

export default HeaderDropDown